import React from 'react'
import CV from '../../assets/cv.pdf'

const CTA = () => {
  return (
    <div className='cta'>
        <a href="https://www.youtube.com/@ataglanceofficial" target='_blank' className="btn">Visit Youtube Channel!</a>
        <a href="https://www.spatial.io/s/At-A-Glance-64325f439f2805f7f09471d8?share=7035986176836881299" target="_blank" className="btn btn-primary">Visit Virtual World!</a>
    </div>
  )
}

export default CTA